import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import { catchError } from 'rxjs';
import { LoginResponse } from '../interfaces/LoginResponse';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  API_URL = environment.API_URL;

  constructor(private http: HttpClient, public shared: SharedService) { }

  login(json: any){
    let url = `${this.API_URL}/login/auth_app`;
    return this.http.post<LoginResponse>(url, json)
  }

  renewToken(){
    this.API_URL = environment.API_URL;
    let url = `${this.API_URL}/login/rt`;
    let renew_token = this.shared.refresh_token;
    return this.http.post<LoginResponse>(url, {renew_token})
  }

  changePassword(json: any){
    let url = `${this.API_URL}/login/cp`;
    return this.http.post<LoginResponse>(url, json)
  }

}
